import axios from '../request/http';


const merchant = {
    business(params) {
        return axios.get("/admin/business/info/list", {params});
    },
    businessStatus(params) {
        return axios.get("/admin/business/status/update", {params});
    },
    // 商户详情信息
    businessDetail(params) {
        return axios.get("/admin/business/info/detail", {params});
    },
    // 城市列表
    cityList(params) {
        return axios.get("/admin/business/city/list", {params});
    },
    // 商户信息编辑
    businessEdit(data) {
        return axios.post("/admin/business/info/edit", data);
    },
    // 申请服务列表
    businessList(params) {
        return axios.get("/admin/business/list", {params});
    },
    // 申请服务分佣
    businessRevenue(params) {
        return axios.get("/admin/order-management/revenue/list", {params});
    },
    // 获取符合订单条件的商户列表
    businessOkList(params) {
        return axios.get("/admin/business/ok/business", {params});
    },
    // 指定商户派单
    orderSend(params) {
        return axios.get("/admin/business/order/send", {params});
    },
    // 商户服务产品列表
    serveList(params) {
        return axios.get("/admin/business/service/list", {params});
    },
    // 商户服务产品新增/编辑服务
    serveListAdd(data) {
        return axios.post("/admin/business/service/edit", data);
    },
    // 服务产品详情
    serveDetail(params) {
        return axios.get("/admin/business/service/detail", {params});
    },
    // 服务产品上下架
    serveDown(params) {
        return axios.get("/admin/business/down", {params});
    },
    // 服务产品删除
    serveDel(params) {
        return axios.get("/admin/business/service/delete", {params});
    },
    // 商户开通/关闭店铺
    openShop(params) {
        return axios.get("/admin/business/open/shop", {params});
    },
    // 承包商新增
    contractAdd(data) {
        return axios.post("/admin/business-contract/info/addBatch", data);
    },
    // 承包商列表
    contractList(params) {
        return axios.get("/admin/business-contract/info/list", {params});
    },
    // 商户承包商信息修改
    contractEdit(data) {
        return axios.post("/admin/business-contract/info/update", data);
    },
    // 商户承包服务列表
    contractServiceList(params) {
        return axios.get("/admin/business-contract/info/serviceList", {params});
    },
    //商户信息导出
    exportmerchants(params){
        return  axios.get("/admin/business/info/list/export",{params,responseType: 'arraybuffer'});
    },
    // 新增/编辑服务规格
    serviceSpecAdd(data){
        return  axios.post("/admin/business/service/spec/edit",data);
    },
    // 商户服务规格列表
    serviceSpecList(params){
        return  axios.get("/admin/business/service/spec/list",{params});
    },
    // 派单给商户
    allotEdit(params){
        return  axios.get("/admin/allot/edit",{params});
    },
}

export default merchant;


// WEBPACK FOOTER //
// ./src/api/merchant.js